import React from "react";
import { useDispatch } from "react-redux";
import { menuSlice } from "redux/slices/menuSlice";
import { FaIcon } from "lib/FaIcon";
import { _t, i18n } from "app/i18n/i18n";
import { isIntranetPath, isProdEnv, BiLink, isDevEnv, isExtranet } from "lib/routing";
import { auditMenuClick } from "lib/analytics/auditEvents";
import { miscSlice } from "redux/slices/miscSlice";
import { NewIcon } from "pages/redesign/header/desktop/DesktopHeaderParts/DesktopHeaderParts";
import { setAssetClass } from "pages/redesign/menuFilterBar/api/setAssetClass";

export const MenuLink = ({
  link,
  label = lastPart(link),
  icon,
  textLabel,
  action,
  value,
  internalOnly,
  extranetOnly,
  nonProdOnly,
  devOnly,
  desktopOnly,
  isMobile,
  isNew,
}) => {
  const dispatch = useDispatch();
  if (extranetOnly && isIntranetPath()) return null;
  if (internalOnly && isExtranet()) return null;
  if (nonProdOnly && isProdEnv) return null;
  if (devOnly && !isDevEnv) return null;
  if (desktopOnly && isMobile) return null;

  const dispatchActions = () => {
    dispatch(menuSlice.actions.setShowMenu(false));
    if (link.endsWith("Podcast")) {
      const baseUrl = window.location.origin;
      const language = i18n.getLanguage() === "ja" ? "jp/" : "";
      const path = `/research/m/GotoWarning?url=https://www.nomuraconnects.com/${language}podcasts&warn=1&target=_blank`;
      window.location.assign(`${baseUrl}${path}`);
      return;
    }
    if (action) dispatch(miscSlice.actions.set({ key: action, value: JSON.parse(value) }));
    auditMenuClick(link);
  };

  const handleClick = (e) => {
    dispatchActions();
    setAssetClass(e, label);
  };

  const iconTextLabel = textLabel ? <span className="fa-fw mr-3 font-weight-bold">{textLabel}</span> : null;
  const iconLabel = icon ? <FaIcon icon={icon} align="" className="mr-3 fa-lg_off align-middle" /> : iconTextLabel;
  const activeClass = isActive(link) ? "active" : "";

  return (
    <BiLink to={link} onClick={handleClick} className={activeClass}>
      {iconLabel} {_t(label)}
      {isNew && <NewIcon style={{ marginLeft: 6 }} />}
    </BiLink>
  );
};

const lastPart = (path) => path.split("/").slice(-1).join();

const isActive = (link) => decodeURI(window.location.pathname).endsWith(link.replace(/\?.*/, ""));
